import { BootloaderState } from '../types'
import Bootloader from '../../models/bootloader'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'

//Get an Bootloader from a Vue component by calling this.$store.state.bootloader.list;

const state: BootloaderState = {
    list: [],
}

const getters: GetterTree<BootloaderState, any> = {
    getBootloaderList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<BootloaderState> = {
    setBootloaderList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((bootloader: Bootloader, index) => {
            Vue.set(state.list, index, bootloader);
        });
    }
}

const actions: ActionTree<BootloaderState, any> = {
    async fetchBootloaders({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/remote/bootloaders/list";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<Bootloader[]>>)
            .then(data => {
                if (data.result && data.result.length > 0) {
                    const bootloaders = [];
                    data.result.forEach(f => {
                        bootloaders.push(new Bootloader(f));
                    })
                    commit('setBootloaderList', bootloaders);
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}